/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-one-expression-per-line */
// DEPENDENCIES
import React, { useState, useEffect } from 'react';
// COMPONENTS
import Slider from 'react-slick';
// ICONS
import { LiaShippingFastSolid } from 'react-icons/lia';
import CarrierContractNegotiation from '../../../assets/img/illustration_carrier-contract-negotiation.svg';
import ShippingOptimization from '../../../assets/img/illustration_shipping-optimization.svg';
import CarrierBidManagement from '../../../assets/img/illustration_carrier-bid-management.svg';
// import CarrierSelection from '../../../assets/img/illustration_carrier-selection.svg';
// import CarrierCompliance from '../../../assets/img/illustration_carrier-compliance-monitoring.svg';
// CUSTOM COMPONENTS
import CustomBlock from '../../../components/CustomBlock';
import Overlay from '../../../components/Overlay';
import Banner from '../../../components/Banner';
import AnimatedLogo from '../../../components/AnimatedLogo';
import Image from '../../../components/Image';
import Button from '../../../components/Button';
// import ContentStrip from '../../../components/ContentStrip';
// ASSETS - APP LINKS
// import AppStoreBadge from '../../../assets/img/app-store-badge.svg';
// import GooglePlayBadge from '../../../assets/img/google-play-badge.svg';
import BannerImage from '../../../assets/img/homepage-banner-image_default.png';
import BackgroundDecorationImage from '../../../assets/img/background-decoration_dark-light-waves.svg';
import BackgroundTexture from '../../../assets/img/background-texture-1.svg';
// HELPERS
import constants from '../../../constants/constants';
// SERVICES

const HomePage = (props) => {
  // const { dynamicPageModel, buttonAction, cmsInfo, history } = props;
  const { dynamicPageModel, buttonAction, history } = props;
  const [isLoading] = useState(false);
  const [banners, setBanners] = useState([]);
  const [offset, setOffset] = useState(0);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const servicesOverview = [
    {
      title: 'Rate Negotiation',
      illustration: CarrierContractNegotiation,
      description: 'Unlock cost-saving shipping rates with our expert negotiators. We use deep industry knowledge to secure deals that cut costs and boost your savings.',
    },
    {
      title: 'Streamlined Shipping',
      illustration: ShippingOptimization,
      description: 'Our customized shipping strategies enhance your operational efficiency, ensuring reliable delivery without overspending.',
    },
    {
      title: 'Contract Monitoring',
      illustration: CarrierBidManagement,
      description: 'We keep a watchful eye on your shipping contracts, ensuring full compliance and persistent savings.',
    },
    // {
    //   title: 'Carrier Selection',
    //   illustration: CarrierSelection,
    //   description: '',
    // },
    // {
    //   title: 'Carrier Compliance and Monitoring',
    //   illustration: CarrierCompliance,
    //   description: '',
    // },
  ];

  useEffect(() => {
    const rotatingBanners = dynamicPageModel.pageContentSectionBanners.find((x) => x.bannerId > 0);
    if (rotatingBanners) {
      setBanners(rotatingBanners.banner.bannerItems);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => setOffset(window.pageYOffset);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const bannerSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,

    responsive: [
      {
        breakpoint: 480,
        settings: { dots: false }
      }
    ]
  };

  // const navigateToLink = (link) => {
  //   window.open(link, '_blank');
  // };

  return (
    <>
      {(isLoading) && <Overlay hasLoader />}
      <CustomBlock>
        {/* BANNER SECTION */}
        <CustomBlock className="banner-container">
          <Slider {...bannerSliderSettings}>
            {/* CUSTOM BANNER INSERT */}
            <CustomBlock className="custom-banner-container">
              <Banner
                className="custom-banner"
                isTitleUppercase
                title={(
                  <CustomBlock className="custom-banner-content mb-15">
                    <div className="custom-banner-title-container mb-15">
                      <p className="custom-banner-title text-effect-2 fw-500">Ship Smarter, <span className="fw-600">Grow Faster</span></p>
                    </div>
                  </CustomBlock>
                )}
                imageSource={BannerImage}
                description={(
                  <p className="custom-banner-description">Save on shipping, expand your business.<br />Simple, effective logistics with Transport Logics.</p>
                )}
                // primaryActionText="Start Saving Now"
                primaryActionText={(
                  <>
                    <LiaShippingFastSolid size="25px" />
                    Start Saving Now
                  </>
                )}
                primaryActionOnClick={() => {
                  history.push('/transport-logics-services');
                }}
                primaryActionColor="primary--sbg light--clr"
                // secondaryActionText={banner.secondaryButtonText}
                // secondaryActionOnClick={() => {
                //   buttonAction(banner.secondaryButtonActionType, banner.secondaryButtonLink);
                // }}
                offset={offset}
              />
            </CustomBlock>
            {
              banners.map((banner) => (
                <Banner
                  isDynamicBanner
                  isTitleUppercase
                  isReversed={banner.alignment === constants.CONTENT_SECTION.RightAlignment}
                  isCentered={banner.alignment === constants.CONTENT_SECTION.CenterAlignment}
                  title={banner.title}
                  imageSource={`${process.env.REACT_APP_API_URL}Attachments${banner.imagePath}`}
                  description={banner.description}
                  primaryActionText={banner.primaryButtonText}
                  primaryActionOnClick={() => {
                    buttonAction(banner.primaryButtonActionType, banner.primaryButtonLink);
                  }}
                  secondaryActionText={banner.secondaryButtonText}
                  secondaryActionOnClick={() => {
                    buttonAction(banner.secondaryButtonActionType, banner.secondaryButtonLink);
                  }}
                  offset={offset}
                />
              ))
            }
          </Slider>
        </CustomBlock>

        {/* WEBSITE INTRO */}
        <CustomBlock className="responsive-content-section">
          <CustomBlock className="website-intro pb-30">
            <CustomBlock className="svg-container mb-30">
              <AnimatedLogo
                onClick
                width="350px"
              />
            </CustomBlock>
            <p className="responsive-content-section__description description mid-grey--clr size-mdlg pb-30">Shipment Savings, Delivered!</p>
          </CustomBlock>
        </CustomBlock>

        {/* INTRO TO ABOUT */}
        <CustomBlock className="responsive-content-section mb-30">
          <CustomBlock className="intro-to-about" style={{ backgroundImage: `url(${BackgroundTexture})` }}>
            <p className="white--clr responsive-content-section__header pb-20">More Than Parcel Consultants</p>
            <p className="white--clr responsive-content-section__description size-mdlg fw-300">At Transport Logics, we&apos;re more than just consultants; <span className="fw-600">we&apos;re industry pioneers dedicated to optimizing your parcel shipping experience</span>.</p>
            <br />
            <p className="white--clr responsive-content-section__description size-mdlg fw-300 pb-30">With over three decades of specialized insight, <span className="fw-600">we empower your business to navigate the complexities of carrier contracts and logistics with ease</span>. Our strategic analysis and customized solutions ensure your shipping processes are not just efficient but also cost-effective.</p>
            <Button
              text="Elevate Your Shipping Strategy"
              // className={`${primaryActionColor} ${hasRoundCorners ? 'round-corners' : ''}`}
              to="/about-parcel-consulting"
              // onClick={isPrimaryActionTargetBlank ? () => openInNewTab(primaryActionTo) : primaryActionOnClick}
              className="secondary--sbg"
            />
          </CustomBlock>
        </CustomBlock>

        {/* INTROS TO SERVICES */}
        <CustomBlock className="responsive-content-section">
          <Image
            containerClassName="background-decoration-container"
            className="background-decoration"
            source={BackgroundDecorationImage}
          />

          <CustomBlock className="mult-intro">
            <p className="responsive-content-section__header">How We Help You</p>
            <p className="responsive-content-section__description pb-30">Experience the benefits of smarter shipping. Our approach focuses on finding real savings and making your shipping process smoother and more cost-effective.</p>
            <CustomBlock className="listing-block">
              {
                servicesOverview.map((item) => (
                  <CustomBlock className="item" onClick={() => history.push('/transport-logics-services')}>
                    <CustomBlock className="svg-container mb-30">
                      <img src={item.illustration} alt={`${item.title} Illustration`} />
                      {/* <Image src={item.illustration} /> */}
                    </CustomBlock>
                    <p className="header size-mdlg primary--clr fw-600 pb-10">{item.title}</p>
                    {/* <hr /> */}
                    <p className="description mid-grey--clr size-sm">{item.description}</p>
                  </CustomBlock>
                ))
              }
            </CustomBlock>
          </CustomBlock>
        </CustomBlock>

      </CustomBlock>
    </>
  );
};

export default HomePage;